// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1onY6","box":"WorkspacesBox_box__1FYaz","node":"WorkspacesBox_node__MVnkx"};